export default __webpack_public_path__ + "static/media/close2.772a0b40.svg";